import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'baconfirmation';
export const route = 'baconfirmation/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "confirmation" */
/* webpackPrefetch: true */
'../components/ConfirmationPage')));